import React from 'react';
import './availableSubscriptionsForm.css';
import { useDispatch, useSelector } from "react-redux";
import { setAvailableSubscriptionsFormAction } from "../../redux/rootReducer";
import { AVAILABLE_SUBSCRIPTION__FORM_INITIAL } from "../../redux/initialStateConstant";
import { addWorkoutByAvailableSubscriptionSagaAction } from "../../redux/sagaActions";

const AvailableSubscriptionsForm = () => {
    const dispatch = useDispatch();
    const available_subscriptions_form = useSelector(state => state.available_subscriptions_form);
    const booking_users_form = useSelector(state => state.booking_users_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => dispatch(setAvailableSubscriptionsFormAction(AVAILABLE_SUBSCRIPTION__FORM_INITIAL)) }
                        />
                        <div className="form__title">Доступные абонементы</div>
                    </div>
                    <div className="form__field">
                        <div className="a_subscriptions">
                            {
                                available_subscriptions_form.subscriptions.map(elem => {
                                    return (
                                        <div className="a_subscription"
                                             key={ elem.id }
                                             onClick={ () => dispatch(addWorkoutByAvailableSubscriptionSagaAction({
                                                 subscription_id: elem.id,
                                                 booking_id: booking_users_form.id,
                                                 user_id: available_subscriptions_form.user_id,
                                                 child_id: available_subscriptions_form.child_id
                                             })) }
                                        >
                                            <div className="a_subscription__type">{ elem.type }</div>
                                            <div className="a_subscription__meta">
                                                <div className="a_subscription__value">{ `${ elem.workouts_left } ${ elem.workouts_declination }` }</div>
                                                <div className="a_subscription__value">{ elem.expire_value }</div>
                                            </div>
                                            <div className="a_subscription__value">{ elem.coach }</div>
                                            <div className="a_subscription__value">{ elem.time_constraint }</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        {/*<div className="a_subscription__one-time"*/}
                        {/*     onClick={ () => {*/}

                        {/*     } }*/}
                        {/*>Разовое посещение</div>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AvailableSubscriptionsForm;